import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "CHANGE PASSWORD", -1)
const _hoisted_3 = { class: "text-end" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "fa fa-spinner fa-spin",
  "aria-hidden": "true"
}

import { impalaApi } from "@/main";
import { storeToRefs } from "pinia";
import { toast } from "vue3-toastify";
import { useClientStore } from "@/store/ClientStore";
import { onMounted, reactive, ref, watch } from "vue";
import BaseInputPill from "@/components/base-components/BaseInputPill.vue";


const __default__ = {
  name: "ChangePassword",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useClientStore();
const { clientData } = storeToRefs(store);
const { loadUserData } = useClientStore();
const loading = ref(false);

let form = reactive({
  email: "",
  oldPassword: "",
  newPassword: "",
});

watch(clientData, () => {
  if (clientData === undefined) return;
  form.email = clientData.value?.email ?? "";
});

onMounted(() => {
  if (clientData.value === undefined) return;
  form.email = clientData.value?.email ?? "";
});

const resetForm = () => {
  form.oldPassword = "";
  form.newPassword = "";
};

const submit = async () => {
  try {
    loading.value = true;
    const { data: token } = await impalaApi.post(
      `/admin/clients/credentials`,
      form
    );
    localStorage.setItem("token", token);
    let loginForm = {
      email: form.email,
      password: form.newPassword,
    };
    const { data: tokenUpdate } = await impalaApi.post(
      "/auth/login",
      loginForm
    );
    localStorage.setItem("token", tokenUpdate);
    await loadUserData();
    toast.success("Successfully password changed!");
    resetForm();
  } catch (error: never) {
    toast.error("Failed: " + error.response?.data?.message);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(clientData) !== undefined)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        onSubmit: _withModifiers(submit, ["prevent"]),
        role: "form",
        class: "ui form col-12 col-sm-9 mx-auto py-3"
      }, [
        _hoisted_2,
        _createVNode(BaseInputPill, {
          value: _unref(form).oldPassword,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).oldPassword) = $event)),
          name: "oldPassword-change-password",
          type: "password",
          id: "oldPassword-change-password",
          "aria-placeholder": "Old Password",
          placeholder: "Old Password",
          required: ""
        }, null, 8, ["value"]),
        _createVNode(BaseInputPill, {
          value: _unref(form).newPassword,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).newPassword) = $event)),
          name: "newPassword-change-password",
          type: "password",
          id: "newPassword-change-password",
          "aria-placeholder": "New Password",
          placeholder: "New Password",
          required: ""
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            disabled: loading.value,
            class: "btn btn-primary text-light rounded-pill px-5",
            type: "submit"
          }, [
            _createTextVNode(" Save "),
            (loading.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_5))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4)
        ])
      ], 40, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})